import React from 'react';

const PageHeader = ({ title, description, icon, action, actions }) => {
  return (
    <div className="md:flex md:items-center md:justify-between">
      <div className="flex-1 min-w-0">
        <div className="flex items-center">
          {icon && <div className="mr-3">{icon}</div>}
          <h2 className="text-2xl font-bold leading-7 text-gray-900 dark:text-white sm:text-3xl sm:truncate">
            {title}
          </h2>
        </div>
        {description && (
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            {description}
          </p>
        )}
      </div>
      {(action || actions) && (
        <div className="mt-4 flex md:mt-0 md:ml-4">
          {action && (
            <button
              onClick={action.onClick}
              className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              {action.icon}
              {action.label}
            </button>
          )}
          {actions}
        </div>
      )}
    </div>
  );
};

export default PageHeader;